const XMN_DECIMALS = 6;
const FIAT_DECIMALS = 2;

const xmnFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: XMN_DECIMALS,
  maximumFractionDigits: XMN_DECIMALS,
});

const fiatFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: FIAT_DECIMALS,
  maximumFractionDigits: FIAT_DECIMALS,
});

const safeParseFloat = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatXmnValue = (amount) =>
  xmnFormatter.format(safeParseFloat(amount));

const formatFiatValue = (amount) =>
  fiatFormatter.format(safeParseFloat(amount));

const formatXmn = (amount) => `${formatXmnValue(amount)} XMN`;

const formatFiat = (amount, currency) =>
  `${formatFiatValue(amount)} ${currency}`;

const formatPercentage = (decimal) => {
  const percentage = safeParseFloat(decimal) * 100;
  const decimals = percentage % 1 === 0 ? 0 : 1;
  return `${percentage.toFixed(decimals)}%`;
};

export {
  XMN_DECIMALS,
  FIAT_DECIMALS,
  formatXmnValue,
  formatFiatValue,
  formatXmn,
  formatFiat,
  formatPercentage,
};
